module.exports = __webpack_public_path__ + "img/neck_width.3e656bfd.png";